export enum RoomStatus {
  Published = 1,
  Unpublished = 2,
}

export enum RoomStatusLiteral {
  Active = 'Active',
  Inactive = 'Inactive',
  Deleted = 'Deleted',
  Pending = 'Pending',
}
